import {Directive, ElementRef, forwardRef, Inject, Input} from '@angular/core';
import {FormControl, NG_VALIDATORS, Validator} from '@angular/forms';
import {DOCUMENT} from '@angular/common';
import {MomentService} from '../services/moment.service';

@Directive({
    selector: '[lvDatumValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => DatumValidatorDirective),
            multi: true,
        },
    ],
    standalone: false
})
export class DatumValidatorDirective implements Validator {
  @Input()
  public minDate = '1900-01-01';

  @Input()
  public maxDate: string = null;

  constructor(private _momentService: MomentService,
              private _element: ElementRef,
              @Inject(DOCUMENT) private _document: Document) {
  }

  public validate(control: FormControl): { [key: string]: any } | null {
    if (!this._element.nativeElement.value) {
      return null;
    }
    const locale = this._momentService.moment().locale();
    const date = this._momentService.moment(this._element.nativeElement.value, this._momentService.validDateFormat, true); // strict mode
    const minDate = this._momentService.moment(this.minDate, this._momentService.validDateFormat, true); // strict mode
    const maxDate = this._momentService.moment(this.maxDate, this._momentService.validDateFormat, true); // strict mode
    const partialDate = this._momentService.moment(this._element.nativeElement.value, this._momentService.partialDateFormats[locale], true);
    if (date.isValid() && !this._isDateOfLengthSeven(this._element.nativeElement.value)) {
      if (this.minDate && date.isBefore(minDate)) {
        return {ERROR: 'DATE_SMALLER_THAN_MIN_DATE'};
      }
      if (this.maxDate && date.isAfter(maxDate)) {
        return {ERROR: 'DATE_BIGGER_THAN_MAX_DATE'};
      }
      return null;
    } else {
      if (partialDate.isValid() || '0' === this._element.nativeElement.value) {
        return {PARTIAL: 'PARTIAL'};
      } else {
        return {ERROR: 'WRONG_DATE'};
      }
    }
  }

  private _isDateOfLengthSeven(date: any) {
    const stringDate = date.toString();
    return stringDate.indexOf('.') < 0 && stringDate.length === 7;
  }
}
